import { invalidateMenuCache } from '@fff-web/fff-global-nav';
import { invalidateUserCache } from '@fff-web/fff-utilities';
import { invalidateMemberCaches } from '../services/member-caches';
import { syncDelay } from './index';

const invalidateCaches = async () => {
  invalidateUserCache();
  syncDelay(1000);
  invalidateMenuCache();
  syncDelay(4000);
  await invalidateMemberCaches();
};

export default invalidateCaches;
